import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { OneTrustConfigService } from '@core/services/core/one-trust-config.service';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class OneTrustGuardService implements CanActivateChild {

  constructor(
    private platform: Platform,
    private oneTrust: OneTrustConfigService,
  ) {}

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.platform.is('cordova')) {
      this.oneTrust.init();
    }
    return true;
  }
}
